import React from 'react'
import './Offers.css'
import exclusive_image from '../Assets/hero-1.jpg'

const Offers = () => {
  return (
    <div>
    </div>
  )
}

export default Offers